const styles: any = (theme: any) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridColumnGap: '20px'
  }
});
export default styles;
